export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const REMOVE_SELECTED_OPTION = 'REMOVE_SELECTED_OPTION';
export const CLEAR_SELECTED_OPTIONS = 'CLEAR_SELECTED_OPTIONS';

export const setSelectedOption = (option) => ({
  type: SET_SELECTED_OPTION,
  data: { option },
});

export const removeSelectedOption = (optionName) => ({
  type: REMOVE_SELECTED_OPTION,
  data: { optionName },
});

export const clearSelectedOptions = () => ({
  type: CLEAR_SELECTED_OPTIONS,
});

export const setDefaultOptions = (optionsList) => (dispatch, getState) => {
  const {
    options: { selectedOptions, unSelectedKeys } = {},
    claims: { enabled: claimsEnabled } = {},
  } = getState();
  if (optionsList && optionsList.options) {
    // eslint-disable-next-line no-restricted-syntax
    for (const option of optionsList.options) {
      const isUnselectedKey = unSelectedKeys.some((key) => key === option.key);

      if (!selectedOptions[option.key] && option.default && !isUnselectedKey && !claimsEnabled) {
        dispatch(setSelectedOption(option));
      }
    }
  }
};
